module.exports = __webpack_public_path__ + "static/359b38707848cfdb384356808c8ab2cddd08eb7794c3f8f5c46d71a760e5eaa0-76695f191b1400e4fb2b5d47a68cff6b.png";